import script from "./loan-contract-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./loan-contract-list.vue?vue&type=script&lang=ts&setup=true"

import "./loan-contract-list.vue?vue&type=style&index=0&id=efbb4b5e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efbb4b5e"]])

export default __exports__